<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <!-- ログインしてください -->
    <FacePhraseForIndexPage
      v-if="!isLogin || invalidTokens"
      phrase="ログインしてください"
    />

    <!-- BookGroupの一覧 -->
    <TemplateMyCouponsIndex v-else-if="isReadyToDraw" />

    <!-- index画面の描画ローディング -->
    <ItemDialogForIndexPage v-else />
  </div>
</template>

<script>
// Vue
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import TemplateMyCouponsIndex from "@/views/Templates/MyCoupons/TemplateMyCouponsIndex";

// API
import API from "@/API";

export default {
  name: "MyCouponsIndex",
  components: {
    TemplateMyCouponsIndex: TemplateMyCouponsIndex,
  },

  setup() {
    const store = useStore();

    const isLogin = store.getters["common/isLogin"];
    // 他端末でログインした場合、tokenはあるが期限切れで未ログインとして扱う必要がある
    // この画面ではリフレッシュトークンを呼ばないので、別途フラグで管理する
    const invalidTokens = ref(false);
    const isReadyToDraw = ref(false);

    onMounted(async () => {
      // リセット
      store.commit("coupon/setExternalCoupons", []);

      try {
        await API.getExternalCoupons();
        isReadyToDraw.value = true;
      } catch (e) {
        // トークン切れの場合エラーが出るので、未ログインの表示を出す
        invalidTokens.value = true;
        isReadyToDraw.value = true;
      }
    });

    return {
      isLogin,
      invalidTokens,
      isReadyToDraw,
    };
  },
};
</script>
